import { render, staticRenderFns } from "./select-goods-category.vue?vue&type=template&id=31d91a4c"
import script from "./select-goods-category.vue?vue&type=script&lang=js"
export * from "./select-goods-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports